import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Pressable } from "react-native";
import { useFragment } from "react-relay";

import { GiftCardIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { GiftCard_squareGiftCard$key } from "./__generated__/GiftCard_squareGiftCard.graphql";

type GiftCardProps = {
  fragmentRef: GiftCard_squareGiftCard$key | null;
  onPress?: () => void;
};

export const GiftCard = ({ fragmentRef, onPress }: GiftCardProps) => {
  const { currencySymbol } = useGetClubCurrency();
  const card = useFragment(SquareCardFragmentString, fragmentRef);
  return (
    <Pressable
      testID={`gift-card-${card?.squareId}`}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={t`Gift Card ending ${card?.ganLastFour ?? ""}`}
    >
      <HStack py={2} justifyContent="space-between" alignItems="center" gap={2}>
        <Box
          bg="surface-secondary"
          width={40}
          height={26}
          borderRadius="2"
          justifyContent="center"
          alignItems="center"
        >
          <GiftCardIcon />
        </Box>
        <VStack flexGrow={1}>
          <HStack gap={1}>
            <Text variant="mainBaseSemiBold">{t`Gift Card ending ${
              card?.ganLastFour ?? ""
            }`}</Text>
          </HStack>
          <Text variant="mainTiny" color="text-secondary">
            {`${currencySymbol}${ConvertCentsToDollars(card?.balance ?? 0)}`}
          </Text>
        </VStack>
      </HStack>
    </Pressable>
  );
};

const SquareCardFragmentString = graphql`
  fragment GiftCard_squareGiftCard on SquareGiftCard {
    __typename
    id
    balance
    ganLastFour
    status
    squareId
    createdAt
  }
`;
